export const RouterLists = [
  {
    path: "/StoreAudit",
    name: "店铺审核",
    component: () => import("@/views/StoreAudit/index.vue"),
    meta: {
      requireAuth: true
    }
  },

  {
    path: "/StoreAudit/detail",
    name: "店铺详情",
    hidden: true,
    component: () => import("@/views/StoreAudit/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/welfare",
    name: "福利管理",
    component: () => import("@/views/welfare/index.vue"),
    meta: {
      requireAuth: true
    }
  },

  {
    path: "/JobType",
    name: "职位管理",
    component: () => import("@/views/JobType/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/Role",
    name: "角色管理",
    component: () => import("@/views/Role/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/user",
    name: "用户管理",
    component: () => import("@/views/user/index.vue"),
    meta: {
      requireAuth: true
    }
  },
 
  {
    path: "/SalesmanStatistics",
    name: "商户统计",
    component: () => import("@/views/SalesmanStatistics/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/SalesmanStatistics/detail",
    name: "商户详情",
    component: () => import("@/views/SalesmanStatistics/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/salesperson",
    name: "业务员管理",
    component: () => import("@/views/salesperson/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/salesperson/detail",
    name: "业务员详情",
    component: () => import("@/views/salesperson/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/Add_PartTime_Job",
    name: "添加兼职",
    component: () => import("@/views/Add_PartTime_Job/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/member",
    name: "会员列表",
    component: () => import("@/views/member/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/lowestSalary",
    name: "工资/保证金/群二维码管理",
    component: () => import("@/views/lowestSalary/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/Allbill",
    name: "账单明细",
    component: () => import("@/views/Allbill/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/Allbill/detail",
    name: "账单明细",
    component: () => import("@/views/Allbill/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/contract",
    name: "合同管理",
    component: () => import("@/views/contract/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/invoice",
    name: "发票管理",
    component: () => import("@/views/invoice/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/invoice/detail",
    name: "发票明细",
    component: () => import("@/views/invoice/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/recruit",
    name: "招聘列表",
    component: () => import("@/views/recruit/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/recruit/detail",
    name: "招聘列表",
    component: () => import("@/views/recruit/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/StoreHistory",
    name: "店铺招聘历史",
    component: () => import("@/views/StoreHistory/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/appeal",
    name: "申诉管理",
    component: () => import("@/views/appeal/index.vue"),
    meta: {
      requireAuth: true
    }
  },
 
  {
    path: "/appeal/detail",
    name: "appealsDetail",
    component: () => import("@/views/appeal/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/feedback",
    name: "用户反馈",
    component: () => import("@/views/feedback/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/feedback/detail",
    name: "appealDetail",
    component: () => import("@/views/feedback/detail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/Withdrawal",
    name: "提现列表",
    component: () => import("@/views/Withdrawal/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/attendance",
    name: "考勤",
    component: () => import("@/views/attendance/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/memberDetail",
    name: "会员详情",
    component: () => import("@/views/member/memberDetail.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/Menus",
    name: "菜单管理",
    component: () => import("@/views/Menus/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/notification",
    name: "通知管理",
    component: () => import("@/views/notification/index.vue"),
    meta: {
      requireAuth: true
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/list.js